import React from 'react';
import { Empty, Typography, theme } from 'antd';

type AiInsightsEmptyStateProps = {
  headline: string;
  body: string;
};

/**
 * The single empty-state representation for AI Insights sections:
 * the simple Empty illustration, a headline and a muted body line.
 */
function AiInsightsEmptyState({ headline, body }: AiInsightsEmptyStateProps) {
  const { token } = theme.useToken();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <Typography.Text style={{ fontSize: token.fontSize }}>{headline}</Typography.Text>
      }
    >
      <Typography.Text style={{ color: token.colorTextQuaternary, fontSize: token.fontSize }}>
        {body}
      </Typography.Text>
    </Empty>
  );
}

export default AiInsightsEmptyState;
